export default {
  getAll(context, params) {
    // const searchTerms = new URLSearchParams(params).toString();
    // let news = searchTerms.replace(/[+]/g, "%2B");
    let news = encodeURIComponent(params);
    return new Promise((resolve, reject) => {
      window.axios
        .get(`courses/search?query=${news}`)
        .then(response => {
          context.commit("setBlog", response.data.blogs);
          context.commit("setCourses", response.data.courses);
          context.commit("setNews", response.data.news);
          context.commit("setProducts", response.data.products);
          context.commit("setLessons", response.data.lessons);
          resolve(response.data);
        })
        .catch(reject);
    });
  }
};
